export const FONT = {
  SANS_13_BOLD: 'SANS_13_BOLD',
  SANS_13: 'SANS_13'
}

export const FALLBACK_CHAR_WIDTH = 12
